import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddResourceQuestionComponent } from '../add-resource-question/add-resource-question.component';
import { AddResponseComponent } from '../add-response/add-response.component';
import { ResourcesService } from '../services/resources.service';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-desktop-resources-questions',
  templateUrl: './desktop-resources-questions.component.html',
  styleUrls: ['./desktop-resources-questions.component.css']
})
export class DesktopResourcesQuestionsComponent implements OnInit {

  constructor(public _resourcesServices: ResourcesService, public _dialog: MatDialog, public snackbar: MatSnackBar, public log: LogService) { }

  public allQuestions = [];
  public emptyQuestion = false;
  public message = "";
  public response;
  public spinner = true;
  public selectedOption = 0;

  ngOnInit() {
    this._resourcesServices.questionObj.subscribe(response => {
      this.response = response;
      this.selectedOption = 0;
      this.log
        .addLog({
        action: "Access",
        component: "Resources Question",
        details: `Accessed & Fetched Resources Question in resource - ${this.response.resource_det.resource} - ${this.response.resource_det.topic} - ${this.response.resource_det.title}`,
      }).subscribe(data => { });
      this.getResourceQuestions();

    })
    
  }

  getAllQuestions() {
    this.spinner = true;
    let obj = {course_id: this.response.course_id, resource_id: "all"};
    this._resourcesServices.getResourcesQuestions(obj).subscribe(data => {
      this.allQuestions = data;
      if (this.allQuestions.length <= 0) {
        this.emptyQuestion = true;
        this.message = `No Question in this course yet! Click "+" to ask a question`;
      } else if(this.allQuestions.length != 0) {
        this.emptyQuestion = false;
        this.message = "";
      }
      this.spinner = false;
    })
  }

  getResourceQuestions() {
    this.spinner = true;
    let obj = {course_id: this.response.course_id, resource_id: this.response.resource_id};
    this._resourcesServices.getResourcesQuestions(obj).subscribe(data => {
      this.allQuestions = data;
      if (this.allQuestions.length <= 0) {
        this.emptyQuestion = true;
        this.message = `No Question in this Lecture yet! Kindly View questions for all lectures or click "+" to ask a question`;
      } else if(this.allQuestions.length != 0) {
        this.emptyQuestion = false;
      }
    })
    this.spinner = false;
  }

  addQuestions () {
    this.spinner = true;
    let dialog = this._dialog.open(AddResourceQuestionComponent, {
      data: {course_id: this.response.course_id},
      width: '600px'
    })
    dialog.afterClosed().subscribe(response => {
      this.spinner = false;
      if (response.success == true) {
        this.log
        .addLog({
          action: "Add",
          component: "Resources Question",
          details: `Asked a ${response.type} in Resources- ${this.response.resource_det.resource} - ${this.response.resource_det.topic} - ${this.response.resource_det.title}`,
        }).subscribe(data => { });
        this.getAllQuestions()
      } else {
        this.snackbar.open("Failed", "Dismiss", {
          duration: 3000
        })
      }
      this.spinner = false;
    })
  }

  addResponse (resource_question_id, question_title, question, resource) {
    let dialog = this._dialog.open(AddResponseComponent, {
      data: {course_id: this.response.course_id, resource_question_id, question_title, question, resource_id: this.response.resource_id, resource},
      width: '600px',
      height: '90vh',
    })
    dialog.afterClosed().subscribe(data => {
      this.getAllQuestions();
    })
  }

  selectByLecture() {
    this.message = "";
    // 0 for the default lecture and 1 for all lecture/resource
    if (this.selectedOption == 0) {
      this.getResourceQuestions();
    } else if (this.selectedOption == 1) {
      this.getAllQuestions();
    }
  }

}
